import { render } from "./BlogSocialShare.vue?vue&type=template&id=5470c8f7"
import script from "./BlogSocialShare.vue?vue&type=script&lang=js"
export * from "./BlogSocialShare.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__